import styled from 'styled-components';

import { IconRegularCopy, InteractiveArea, theme } from '@notino/react-styleguide-v20';

import { CheckoutPrice } from '@sharedComponents/Prices';

export const StyledInteractiveArea = styled(InteractiveArea)`
  vertical-align: middle;
  position: relative;
  margin-left: 0.25rem;
  top: -0.125rem;
  height: 1rem;
  z-index: 99;
  cursor: pointer;
`;

export const StyledDiscountedPrice = styled(CheckoutPrice)`
  color: ${theme.color.text.highlight};
  font-weight: bold;
  margin-right: 0.25rem;
  font-size: 1rem;
`;

export const StyledVoucherUnderProduct = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 0.5rem;
  flex-wrap: wrap;
`;

export const StyledVoucherCode = styled.div`
  text-transform: uppercase;
  font-size: 0.875rem;
  font-weight: bold;
`;

export const StyledMessage = styled.div`
  font-size: 0.875rem;
  margin-right: 0.25rem;
`;

export const StyledIconRegularCopy = styled(IconRegularCopy)`
  width: 1.25rem;
  height: 1.25rem;
  color: #6b6b6b;

  @media (max-width: ${theme.breakpoints.md}rem) {
    width: 1.5rem;
  }
`;

export const STooltipMessageWrapper = styled.div`
  font-size: 0.8rem;
`;
